export default {
  title: 'Easy Air Screen',
  subtitle: 'Convierte tu tableta en un segundo monitor inalámbrico',
  description: 'Transforma tu tableta en una pantalla inalámbrica de alta calidad para macOS. Expande tu espacio de trabajo y aumenta la productividad—sin cables necesarios.',
  downloadMobile: 'Descargar Aplicación Móvil',
  purchasePromise: 'Un solo pago. Sin suscripción ni anuncios.',
  companionPromise: 'La aplicación para Mac es gratuita y no requiere una cuenta.',
  downloadMacOS: 'Descargar para macOS (Universal)',
  quickSetup: 'Configuración Rápida',
  setupSteps: [
    'Instala Easy Air Screen en tu tableta',
    'Descarga e instala la aplicación de escritorio para macOS',
    'Conecta ambos dispositivos a la misma red Wi-Fi',
    '¡Inicia y conecta!'
  ],
  performanceTip: 'Consejo de Rendimiento',
  performanceDescription: 'Para la mejor experiencia con un retraso mínimo, usa una conexión Wi-Fi de 5GHz en ambos dispositivos. Si notas latencia, intenta reducir la resolución en la configuración de la aplicación.',
  faqTitle: 'Preguntas frecuentes',
  faq: [
    {
      q: '¿En qué se diferencia de Sidecar?',
      a: 'Easy Air Screen funciona aunque los dos dispositivos usen Apple ID diferentes. También puedes usar una tableta Android como pantalla secundaria inalámbrica para tu Mac.'
    },
    {
      q: '¿Puedo usarlo con una tableta Android?',
      a: 'Sí. Puedes usar una tableta Android como pantalla secundaria inalámbrica para tu Mac. Conecta ambos dispositivos a la misma Wi-Fi para extender o duplicar la pantalla.'
    },
    {
      q: '¿Un iPhone puede ser una pantalla secundaria?',
      a: 'Sí. Un iPhone puede usarse como pantalla secundaria inalámbrica para tu Mac. Al conectarlo, puedes elegir entre extender el escritorio o duplicar la pantalla.'
    },
    {
      q: '¿Extiende la pantalla o la duplica?',
      a: 'Admite ambas opciones. Puedes extender el escritorio de tu Mac a otra pantalla o duplicar la pantalla actual para mostrar lo mismo en los dos dispositivos.'
    },
    {
      q: '¿Necesito internet? ¿Mi pantalla sale de la red?',
      a: 'No necesitas conexión a internet. Los dispositivos se conectan directamente en la misma Wi-Fi y la pantalla no pasa por servidores externos ni se almacena.'
    },
    {
      q: '¿Es una suscripción?',
      a: 'No. La app para el dispositivo se compra una sola vez, no es una suscripción y no tiene anuncios. La app complementaria para Mac es gratuita y no requiere cuenta.'
    },
    {
      q: '¿Funciona también en PC con Windows?',
      a: 'No. Easy Air Screen está diseñado solo para macOS. Windows PC no es compatible actualmente.'
    },
    {
      q: '¿Qué hago si la pantalla va lenta o se entrecorta?',
      a: 'Conecta ambos dispositivos a una red Wi-Fi de 5GHz si está disponible. Si aún notas retraso, baja la resolución desde los ajustes de la app.'
    },
  ]
};
